import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledTitle = styled.h2`
  background-color: ${props => props.theme.colors.grayLightest};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  border-bottom: 0;
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.xsmall};
  margin: 0;
  padding: ${rem('6px')} ${rem('10px')} ${rem('6px')} ${rem('10px')};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('desktop')`
    border: 0;
    border-bottom: ${rem('2px')} solid ${props => props.theme.colors.dark};
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${props => props.theme.fontSize.small};
    padding: ${rem('6px')} ${rem('10px')} ${rem('6px')} 0;
  `};
`;
